import React, { useContext, useState, useReducer } from 'react';

import Layout from '../../common_components/Layout';
import InnerTabs from '../../common_components/InnerTabs';
import { PlotAdjustForm, ExportForm } from '../components/Forms';
import { SvgPlot } from '../../common_components/SvgPlot';
import { AppContext } from '../contexts';

function selectedSideFieldsReducer(state, action) {
  if (action.type === 'change') {
    const fieldFormName = action.fieldFormName;
    const newValue = action.newValue;
    const visualizationTab = action.visualizationTab;
    const fieldDataIdx = state[visualizationTab].findIndex(
      ({ form_name }) => form_name === fieldFormName,
    );
    const newState = { ...state };
    newState[visualizationTab][fieldDataIdx].default_value = newValue;
    return newState;
  }
  throw new Error('Invalid action type');
}

export default function Visualization({ data, name }) {
  const initialPlot = 'timeseries';
  const app = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(true);
  const [selectedVisualization, setSelectedVisualization] =
    useState(initialPlot);
  const [visualizationData, setVisualizationData] = useState({
    timeseries: null,
    correlationmatrix: null,
  });
  const [selectedSideFields, dispatchSelectedSideFields] = useReducer(
    selectedSideFieldsReducer,
    {
      timeseries: data?.['form_data']?.timeseries,
      correlationmatrix: data?.['form_data']?.correlationmatrix,
    },
  );
  const formSubmitRequest = (formData) =>
    app.APIs.steps.visualization(
      app.activeProject.id,
      name,
      selectedVisualization,
      app.activeProject.filehash,
      formData,
    );
  const onFormSubmitSuccess = (data) => {
    setVisualizationData((p) => ({
      ...p,
      [selectedVisualization]: data,
    }));
  };

  [
    {
      form_name: 'variables_to_plot',
      label: 'Zmienne',
      type: 'multiselect',
      values: [
        {
          label: 'conc',
          value: 'conc',
        },
        {
          label: 'ws',
          value: 'ws',
        },
        {
          label: 'wd',
          value: 'wd',
        },
        {
          label: 'tt',
          value: 'tt',
        },
        {
          label: 'rh',
          value: 'rh',
        },
        {
          label: 'blh',
          value: 'blh',
        },
        {
          label: 'pres',
          value: 'pres',
        },
        {
          label: 'tskc',
          value: 'tskc',
        },
        {
          label: 'ssrd',
          value: 'ssrd',
        },
      ],
      default_value: [
        {
          label: 'conc',
          value: 'conc',
        },
        {
          label: 'ws',
          value: 'ws',
        },
        {
          label: 'wd',
          value: 'wd',
        },
        {
          label: 'tt',
          value: 'tt',
        },
        {
          label: 'rh',
          value: 'rh',
        },
        {
          label: 'blh',
          value: 'blh',
        },
        {
          label: 'pres',
          value: 'pres',
        },
        {
          label: 'tskc',
          value: 'tskc',
        },
        {
          label: 'ssrd',
          value: 'ssrd',
        },
      ],
      min_allowed: 2,
    },
    {
      form_name: 'x_axis_range',
      label: 'Zakres dat',
      type: 'date_range',
      min_value: '2011-01-01',
      max_value: '2022-12-31',
      default_value: {
        min: '2011-01-01',
        max: '2022-12-31',
      },
    },
  ];

  return (
    <Layout
      title="Wizualizacja"
      sideContent={
        <>
          {data && (
            <PlotAdjustForm
              fieldsData={selectedSideFields[selectedVisualization]}
              saveSelectedValues={(fieldName, values) =>
                dispatchSelectedSideFields({
                  type: 'change',
                  fieldFormName: fieldName,
                  newValue: values,
                  visualizationTab: selectedVisualization,
                })
              }
              formSubmitRequest={formSubmitRequest}
              onSubmitSuccess={onFormSubmitSuccess}
              isLoading={isLoading}
              setPlotIsLoading={setIsLoading}
              autoSubmit
            />
          )}
          <ExportForm
            svgBlob={visualizationData[selectedVisualization]}
            isLoading={isLoading}
          />
        </>
      }
      mainContent={
        <>
          <InnerTabs
            tabs={[
              {
                label: 'Seria czasu',
                content: visualizationData['timeseries'] && (
                  <SvgPlot imgBlob={visualizationData['timeseries']}></SvgPlot>
                ),
                onClick: () => setSelectedVisualization('timeseries'),
                defaultChecked: initialPlot == 'timeseries',
              },
              {
                label: 'Macierz korelacji',
                content: visualizationData['correlationmatrix'] && (
                  <SvgPlot
                    imgBlob={visualizationData['correlationmatrix']}
                  ></SvgPlot>
                ),
                onClick: () => setSelectedVisualization('correlationmatrix'),
                defaultChecked: initialPlot == 'correlationmatrix',
              },
            ]}
            isLoading={isLoading}
          ></InnerTabs>
        </>
      }
    ></Layout>
  );
}
